(function ($) {


    let $customPositionedSections;


    const tabletMediaQueryList = window.matchMedia("(max-width: 768px)");
    let isTabletBreakpoint = tabletMediaQueryList.matches;

    tabletMediaQueryList.addEventListener?.("change", checkIfTabletBreakpoint) || tabletMediaQueryList.addListener(checkIfTabletBreakpoint);

    tabletMediaQueryList.addEventListener?.("change", checkIfTabletBreakpoint) || tabletMediaQueryList.addListener(checkIfTabletBreakpoint);


    function checkIfTabletBreakpoint() {
        isTabletBreakpoint = tabletMediaQueryList.matches;
        placeCustomPositionedSections();
    }



    function placeCustomPositionedSections() {
        if (!$customPositionedSections || !$customPositionedSections.length)
            return;

        // console.log('isTabletBreakpoint', isTabletBreakpoint)
        // console.log('isTabletBreakpoint', isTabletBreakpoint)


        $customPositionedSections.each(function () {
            const $thisEl = $(this);
            const thisOrderIndexToSet = parseInt($thisEl.data('mobile-order-index'))


            // if we need to move
            if (isTabletBreakpoint) {
                if (!thisOrderIndexToSet || isNaN(thisOrderIndexToSet))
                    return;

                const $parent = $thisEl.parent();
                const $siblings = $parent.children();

                if (thisOrderIndexToSet <= 0) {
                    $thisEl.prependTo($parent);
                }
                else if (thisOrderIndexToSet >= $siblings.length - 1) {
                    $thisEl.appendTo($parent);
                }
                else {
                    $thisEl.insertBefore($siblings.eq(thisOrderIndexToSet));
                }
            }

            else if ($thisEl.index() === thisOrderIndexToSet) {
                // console.log('$thisEl.index()', $thisEl.index())
                // console.log('thisOrderIndexToSet', thisOrderIndexToSet)
                const predecessorElementId = $thisEl.data('predecessor-id');
                const $predecessorElement = predecessorElementId ? $('#' + predecessorElementId) : null;

                // console.log('predecessorElementId', predecessorElementId)
                // console.log('$predecessorElement', $predecessorElement)

                if ($predecessorElement && $predecessorElement.length > 0) {
                    $thisEl.insertAfter($predecessorElement);
                }
            }
        })
    }



    $(document).on('ready', function () {

        $customPositionedSections = $('[data-mobile-order-index]');

        // remembering where $thisEl was before it was moved from its original place
        $customPositionedSections.each(function() {
            const $predecessorEl = $(this).prev();

            if ($predecessorEl.length) {
                $predecessorEl.attr('id', $(this).data('predecessor-id'));
            }
        });

        checkIfTabletBreakpoint();

    });


})(jQuery);